import { useEffect, useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { AppBar } from "../sidebar/Sidebar-drawer";
import { AvatarData } from "../sidebar/sidebar-data";
import logoDarkIcon from "../../assets/brand/logoDarkIcon.png";
import SearchInput from "../sidebar/search-input";
import { authActions, useAppDispatch, useAppSelector } from "../../store/store";
import { ReactComponent as Logout } from "../../assets/SVG/layout/logout.svg";
import { apiGetRequest } from "../../helpers/Requests";
import { Notifications, Message, Menu, AccessTime, ExpandLess } from "@mui/icons-material";
import { Box, Toolbar, List, IconButton, ListItem, ListItemText, Stack, Card, Typography, useMediaQuery, Badge, ClickAwayListener, Button } from "@mui/material";
import { getProfileData } from "store/features/getProfileDataSlice";
import { decryptRole } from "App";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { getNotificationDetails } from "store/features/notificationSlice";
import { v4 as uuidv4 } from 'uuid';
import '../sidebar/Sidebar.scss';
import ApiClient from "helpers/ApiClient";

dayjs.extend(relativeTime);
const Header = (props: any) => {
  const { open, setOpen, openNotificationModal, setOpenNotificationModal } = props;
  const navigate = useNavigate();
  const [notificationMessage, setNotificationMessage] = useState(false);
  const [modal, setModal] = useState(false);
  const isResponsive = useMediaQuery("(max-width:1023px)");
  const isMobileResponsive = useMediaQuery("(max-width:576px)");
  let userData = JSON.parse(localStorage.getItem("userData") || sessionStorage.getItem("userData") || "null");
  const userRole = decryptRole(userData?.role, "role are");
  const notificationData = useAppSelector((state) => state?.notificationsData);
  const userProfileData = useAppSelector((state: any) => state.profile.user);
  const [profile, setProfile] = useState(userProfileData);
  const [totalNotifications, setTotalNotications] = useState(3)

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getProfileData());
  }, [dispatch]);
  useEffect(() => {
    setProfile(userProfileData);
  }, [userProfileData]);
  useEffect(() => {
    dispatch(getNotificationDetails());
  }, [])
  const placeholderImage = `https://ui-avatars.com/api/?rounded=true&name=${profile.firstName} ${profile.lastName}`;
  const onImageError = (e: any) => {
    e.target.src = placeholderImage;
  };
  const readAllNotications = () => {
    setTotalNotications(!notificationMessage ? (notificationData?.notificationList?.length) : (notificationData?.notificationList?.length - totalNotifications + 3))
  }
  const url = process.env.REACT_APP_BASE_URL + "users/signout";
  const logOutHandler = () => {
    dispatch(authActions.logout());
    dispatch(authActions.clickedRememberMe(false));
    apiGetRequest(url, userData.token)
  };
  return (
    //Header
    <AppBar position="relative" sx={{ pr: !isResponsive ? "25px" : "0px" }}>
      <Toolbar className={!isResponsive ? "toolbar" : ""}>
        {isResponsive && <img src={logoDarkIcon} alt="logo-icon" />}
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ width: "100%", ml: "20px" }}>
          {/* search menu icon */}
          <Stack direction="row" spacing={2} justifyContent="space-between">
            <IconButton onClick={() => setOpen(!open)} disableRipple>
              <Menu className="grey-color" />
            </IconButton>
            {!isMobileResponsive && <SearchInput />}
          </Stack>
          {/* Header icons */}
          <Box className="icons">
            <Stack direction="row" justifyContent="space-between" spacing={3} alignItems="center" sx={{ mr: "10px" }}>
              {userRole !== "Admin" && (
                <IconButton
                  disableRipple
                  onClick={() => {
                    navigate("/inbox", { replace: true });
                    setModal(false);
                    setOpenNotificationModal(false);
                  }}
                >
                  <Message className="grey-color" />
                </IconButton>
              )}
              <Box position="relative">
                <IconButton
                  disableRipple
                  sx={{ p: 0 }}
                  onClick={() => {
                    setOpenNotificationModal(!openNotificationModal);
                    setModal(false);
                  }}
                >
                  {notificationData?.notificationList.length !== 0 ? <Badge badgeContent={notificationData?.notificationList.length > 0 ? notificationData?.notificationList.length : '0'} >
                    <Notifications className="grey-color" />
                  </Badge> : <Notifications className="grey-color" />}
                </IconButton>
                {/*All notifications */}
                {openNotificationModal && (
                  <div className={`notification-modal ${notificationMessage ? 'readAllNotify' : 'helo'}`}>
                    {!isMobileResponsive && (
                      <ExpandLess
                        fontSize="large"
                        sx={{
                          position: "absolute",
                          color: "#E5E5E5",
                          right: "-4px",
                          top: "-22px",
                        }}
                      />
                    )}
                    <Card sx={{ p: "20px" }}>
                      {notificationData?.notificationList?.length > 0 &&
                        <Box display='flex'>
                          <Button disableElevation disableRipple sx={{ ml: 'auto', mr: 0, p: 0, mb: 1.2 }} onClick={() => {
                            dispatch(getNotificationDetails())
                            ApiClient.get(`notification/seen?userId=${userData?.id}`)
                            dispatch(getNotificationDetails())
                          }}><span className="fw-700" style={{color:'#17a2b8'}}>Clear all</span></Button>
                        </Box>
                      }
                      <List sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}>
                        {notificationData?.notificationList?.slice(0, totalNotifications)?.map((item: any, index: any) => {
                          return (
                            <div key={uuidv4()}>
                              <ListItem alignItems="flex-start" sx={{ p: "0", mb: "15px" }}>
                                <div className="img-hold border-radius-4">
                                  <img src={logoDarkIcon} alt="error" />
                                </div>
                                <ListItemText
                                  sx={{ m: "0px" }}
                                  primary={item?.type}
                                  secondary={
                                    <>
                                      <span style={{ margin: "0", fontSize: "12px" }}>{item?.description}</span>
                                      <Typography
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                        component="span"
                                        variant="body2"
                                        color="text. primary"
                                      >
                                        <AccessTime
                                          sx={{
                                            fontSize: "15px",
                                            marginRight: "5px",
                                          }}
                                        />
                                        {dayjs(item?.createdAt).fromNow()}
                                      </Typography>
                                    </>
                                  }
                                />
                              </ListItem>
                            </div>
                          );
                        })}
                      </List>
                      <Typography
                        sx={{ textAlign: "center", padding: "5px 0px 0px" }}
                        onClick={() => {
                          readAllNotications()
                          setNotificationMessage(!notificationMessage);
                          
                        }}
                        className="cursor-pointer"
                      >
                        {notificationData?.notificationList?.length > 3 ? (notificationMessage) : notificationData?.notificationList?.length === 0 && (
                          <Typography sx={{ display: "flex", flexDirection: "column", alignItems: "center", lineHeight: 2 }}>
                            <NotificationsActiveIcon sx={{ color: "#6c757d", fontSize: "45px" }} />
                            <span>No Notications</span>
                          </Typography>
                        )}
                        {notificationData?.notificationList?.length > 3 ? notificationMessage ? 'Read Less' : 'Read All Notificatins' : ''}

                      </Typography>
                    </Card>
                  </div>
                )}
              </Box>
              <Box position="relative">
                {/* <ClickAwayListener onClickAway={() => setModal(false)}> */}
                  <IconButton
                    disableRipple
                    sx={{ p: 0,boxShadow: '0px 4px 4px rgb(0 0 0 / 25%), 0px 2px 4px rgb(0 0 0 / 25%)' }}
                    onClick={() => {
                      setModal(!modal);
                      setOpenNotificationModal(false);
                    }}
                  >
                    <img
                      style={{ borderRadius: "50%", objectFit: "cover" }}
                      width={40}
                      height={40}
                      src={profile?.imageId ? profile?.imageId : placeholderImage}
                      alt={profile.firstName}
                      onError={onImageError}
                    />
                  </IconButton>
                {/* </ClickAwayListener> */}
                {/* profile menus like my account , logout etc */}
                {modal && (
                  <div className="profile-modal">
                    {!isMobileResponsive && (
                      <ExpandLess
                        fontSize="large"
                        sx={{
                          position: "absolute",
                          color: "#E5E5E5",
                          right: "2px",
                          top: "-23px",
                        }}
                      />
                    )}
                    <Card sx={{ pt: 0.5, pb: 1, boxShadow: "none" }}>
                      <Stack direction="column" spacing={2}>
                        {AvatarData.map((item, index) => {
                          return (
                            <div key={uuidv4()} style={{ marginTop: 0 }}>
                              {item?.toShowForRole?.includes(userRole) && (
                                <NavLink to={item.path} style={{ textDecoration: "none" }} onClick={() => setModal(false)}>
                                  <Stack direction="row" spacing={2} paddingX={2} style={{ borderBottom: "1px solid #F1F1F1", paddingBlock: "7px" }}>
                                    <div className="grey-color">{item.icon}</div>
                                    <div className="grey-color" style={{ marginTop: "3px" }}>
                                      {item.title}
                                    </div>
                                  </Stack>
                                </NavLink>
                              )}
                            </div>
                          );
                        })}
                        <NavLink to="/authentication/signin" style={{ textDecoration: "none", marginTop: "10px" }} onClick={logOutHandler}>
                          <Stack direction="row" spacing={2} paddingX={2}>
                            <div className="grey-color">
                              <Logout />
                            </div>
                            <div className="grey-color">Logout</div>
                          </Stack>
                        </NavLink>
                      </Stack>
                    </Card>
                  </div>
                )}
              </Box>
            </Stack>
          </Box>
        </Stack>
      </Toolbar >
    </AppBar >
  );
};
export default Header;